// ProfileSection.jsx

// Dependencies
import React from 'react';

// Components
import Profile from '@/components/data/common/profile/Profile';

// Styling
import { homeCss } from '@digital_monorepo/styling';

const ProfileSection = ({ title, fields, data }) => {
  return (
    <div>
      <Profile fields={fields} data={data}></Profile>
    </div>
  );
};

export default ProfileSection;
